import {
  FIELD_AVAILABILITY_RANGES_KEY,
  FIELD_CONVERTED_AVAILABILITY_RANGES_KEY,
  FIELD_SUBTEMPLATE_KEY,
  FORM_ROLES_KEY,
  FORM_SUBTEMPLATES_KEY
} from "PFApp/constants/activity_form/activity_form_field_keys";
import {
  Activity,
  CheckboxesFieldValue,
  CustomValueDateRange,
  Id,
  ParsedSchemaProperty,
  PureCustomValue,
  SkillsFrameworkCustomValue,
  SkillsFrameworkSkill
} from "PFCore/types";

export enum Sections {
  Subtemplate = "subtemplate",
  BasicInformation = "basicInformation",
  SkillsFrameworks = "skillsFrameworks",
  MatchAttributes = "matchAttributes",
  Availability = "availability",
  Attributes = "attributes",
  Privacy = "privacy",
  Attachments = "attachments",
  Conversation = "conversation",
  ShowInterestQuestions = "showInterestQuestions"
}

export type FormSchemaField = {
  name: string;
  segment?: boolean;
  match?: boolean;
  property?: ParsedSchemaProperty;
};

export type FormSchema = Partial<Record<Sections, FormSchemaField[]>>;

export type FormCustomFieldValue = (PureCustomValue | SkillsFrameworkCustomValue | SkillsFrameworkSkill)[];
export type FormFieldValue = FormCustomFieldValue | CheckboxesFieldValue | CustomValueDateRange | Id | string;
export type FormFieldData = {
  values: FormFieldValue;
  fieldName: string;
  bypassReadPermission?: boolean;
};

export type ActivityFormType = Pick<
  Activity,
  | "template_id"
  | "subtemplate_key"
  | "name"
  | "description"
  | "min_required_count"
  | "private"
  | "audiences"
  | "communication_type"
  | "post_until"
  | "post_until_change_reason"
  | "developmental"
  | "skills_framework_ids"
  | "booking_category_id"
  | "metadata"
> & {
  parent_activity?: Activity | null;
  custom_fields: Record<string, FormCustomFieldValue>;
  attachment_ids: Id[];
  interest_questions: string[];
  interest_statement_enabled: boolean;
  interest_questions_toggle?: boolean;
  assignee_id: number | null;

  // Multi-roles form fields
  id?: Id;
  markedForRemoval?: boolean; // to mark existing roles for removal without removing them from the form state, do not submit to API
  uniqueId: string; // an unique role identifier that is not dependant on subtemplate or role index
};

export type MultiActivityForm = {
  [FORM_SUBTEMPLATES_KEY]: {
    [FIELD_SUBTEMPLATE_KEY]: string;
    [FORM_ROLES_KEY]: ActivityFormType[];
  }[];
};

export type RolesFormKey = `${typeof FORM_SUBTEMPLATES_KEY}.${number}.${typeof FORM_ROLES_KEY}`;
export type RoleFormKey = `${RolesFormKey}.${number}`;
export type RangesFieldKey = `${RoleFormKey}.${typeof FIELD_AVAILABILITY_RANGES_KEY}`;
export type ConvertedRangesFieldKey = `${RoleFormKey}.${typeof FIELD_CONVERTED_AVAILABILITY_RANGES_KEY}`;
